<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { colors, shadows } from '@/design-system'

const isVisible = ref(false)

function handleScroll() {
  isVisible.value = window.scrollY > 300
}

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <Transition name="fade">
    <button v-if="isVisible" class="back-to-top" aria-label="Back to top" @click="scrollToTop">
      ↑
    </button>
  </Transition>
</template>

<style scoped>
.back-to-top {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: v-bind('colors.primary');
  color: white;
  border: none;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: v-bind('shadows.lg');
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.back-to-top:hover {
  background: v-bind('colors.primaryHover');
  transform: translateY(-4px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .back-to-top {
    width: 45px;
    height: 45px;
  }
}
</style>
